<template>
  <tela-component title="Emissão de pedido" rota="/">
    <v-progress-linear indeterminate v-if="loading"></v-progress-linear>
    <template v-else>
      <selecionar-usuario-pedido />
      <selecionar-filial-pedido class="mt-2" />
      <selecionar-tipo-pedido class="mt-2" />
      <selecionar-cliente-pedido class="mt-2" />
      <template v-if="novopedido.cliente">
        <v-row dense class="mt-2">
          <v-col xl="8" lg="8" md="8" cols="12">
            <selecionar-frete-cliente />
          </v-col>
          <v-col xl="4" lg="4" md="4" cols="12">
            <informar-entrega />
          </v-col>
        </v-row>
        <informar-forma-pgto-pedido class="mt-2" />
        <informar-produtos-pedido class="mt-2" />
        <informar-opcoes-adicionais class="mt-2 mb-4" />
        <assinatura-pedido
          v-if="getTipoPedidoSelec().assinatura"
          :assinatura_obrigatoria="getTipoPedidoSelec().assinatura_obrigatoria"
          class="mb-4"
        />
        <btn-emitir-pedido />
      </template>
    </template>
  </tela-component>
</template>

<script>
import TelaComponent from "@/components/tela/TelaComponent.vue";
import { mapActions, mapGetters, mapState } from "vuex";
import SelecionarUsuarioPedido from "@/components/pedidos/novo-pedido/SelecionarUsuarioPedido.vue";
import SelecionarFilialPedido from "@/components/pedidos/novo-pedido/SelecionarFilialPedido.vue";
import SelecionarClientePedido from "@/components/pedidos/novo-pedido/SelecionarClientePedido.vue";
import SelecionarFreteCliente from "@/components/pedidos/novo-pedido/SelecionarFreteCliente.vue";
import InformarEntrega from "@/components/pedidos/novo-pedido/InformarEntrega.vue";
import InformarFormaPgtoPedido from "@/components/pedidos/novo-pedido/InformarFormaPgtoPedido.vue";
import InformarProdutosPedido from "@/components/pedidos/novo-pedido/InformarProdutosPedido.vue";
import InformarOpcoesAdicionais from "@/components/pedidos/novo-pedido/InformarOpcoesAdicionais.vue";
import BtnEmitirPedido from "@/components/pedidos/novo-pedido/botoes/BtnEmitirPedido.vue";
import SelecionarTipoPedido from "@/components/pedidos/novo-pedido/SelecionarTipoPedido.vue";
import AssinaturaPedido from "@/components/pedidos/novo-pedido/AssinaturaPedido.vue";

export default {
  components: {
    TelaComponent,
    SelecionarUsuarioPedido,
    SelecionarFilialPedido,
    SelecionarClientePedido,
    SelecionarFreteCliente,
    InformarEntrega,
    InformarFormaPgtoPedido,
    InformarProdutosPedido,
    InformarOpcoesAdicionais,
    BtnEmitirPedido,
    SelecionarTipoPedido,
    AssinaturaPedido,
  },
  computed: {
    ...mapState("pedidos", ["novopedido", "config"]),
    ...mapState("base", ["filiais"]),
    ...mapState("usuario", ["usuarioLogado"]),
  },
  data: () => ({
    loading: true,
  }),
  methods: {
    ...mapActions("pedidos", ["getConfigPedidos"]),
    ...mapActions("base", ["getFiliais"]),
    ...mapGetters("pedidos", ["getTipoPedidoSelec"]),
  },  
  async mounted() {
    this.loading = true;
    this.$store.commit("pedidos/resetState");
    this.$store.commit("clientes/resetState");
    this.$store.commit("insumos/resetState");    
    await this.getFiliais();
    await this.getConfigPedidos();
    this.loading = false;
  },
  destroyed() {
    this.$store.commit("clientes/resetState");
  },
};
</script>

<style>
</style>